import React, { FC, useEffect } from 'react';
import { Lights, CanvasBackground, Dialog } from '../../../../components';
import { SpinningShip } from './SpinningShip';
import { SHIP_SHOWCASE_BACKGROUND_TEXTURE } from '../../../../traits';
import { useCamera } from '../../../../utils';
import { ShipConfig } from '../../../../types';

export type ShipShowcaseProps = {
  onComplete?: () => void;
  shipConfig: ShipConfig;
};
export const ShipShowcase: FC<ShipShowcaseProps> = ({
  onComplete,
  shipConfig,
}) => {
  useEffect(() => {
    const advance = () => onComplete && onComplete();
    window.addEventListener('keypress', advance);
    return () => {
      window.removeEventListener('keypress', advance);
    };
  }, [onComplete]);
  useCamera([0, -40, 0], [0, 0, 0], 60);

  return (
    <>
      <Lights />
      <SpinningShip shipConfig={shipConfig} />
      <CanvasBackground texture={SHIP_SHOWCASE_BACKGROUND_TEXTURE} />
      <Dialog
        text={
          'arrow keys - move ship\n' +
          'spacebar - fire\n' +
          'press any key to continue'
        }
        center
        position={[0, 0, -15]}
        size={[50, 10]}
        canvasSize={[200, 40]}
        color={
          SHIP_SHOWCASE_BACKGROUND_TEXTURE.dark
            ? [255, 255, 255, 255]
            : [0, 0, 0, 255]
        }
        background={SHIP_SHOWCASE_BACKGROUND_TEXTURE.dark ? 'black' : 'white'}
      />
    </>
  );
};
